import * as serviceWorker from 'fulogics-ui-web/dist/web/serviceWorker';
import { render } from 'react-dom';
import './index.css';
import './index.module.scss';

//import 'reflect-metadata'
import '@devexpress/dx-core';
import 'react-hot-loader';
import { hot } from 'react-hot-loader/root';

import AppScreen from './layout/screens/app/AppScreen';
import { signalRRegisterCommands } from './signalR/signalRRegisterCommands';
import { store } from './store/store';

import { Singleton } from 'fulogics-ui-core/dist/Singleton';
import { reportWebVitals } from 'fulogics-ui-web/dist/web/reportWebVitals';
import configuration from './configuration';
import { init } from './init';

/*
const whyDidYouRender = require('@welldone-software/why-did-you-render');
whyDidYouRender(React, {
    trackAllPureComponents: true,
  });*/

Singleton.getInstance().coreConfiguration = {
    ...Singleton.getInstance().coreConfiguration,
    ...configuration,
};

init();
//
const HotApp = hot(AppScreen);

signalRRegisterCommands(store, () => {
    render(<HotApp />, document.getElementById('app'));
});
//
serviceWorker.unregister();
//
reportWebVitals();
